import { showInfoSnackbar } from '@juvare/common-web-ui/SnackbarHelper';
import { Container } from '@mui/material';
import React from 'react';
import { InboxCard } from './index';

export default (): React.ReactElement => {
    return (
        <Container maxWidth='sm'>
            <InboxCard
                onRequireResponseClick={() => showInfoSnackbar({ message: 'Notifications require response clicked' })}
                onUnreadClick={() => showInfoSnackbar({ message: 'Unread notifications clicked' })}
            />
        </Container>
    );
};


export const src = "import { showInfoSnackbar } from '@juvare/common-web-ui/SnackbarHelper';\nimport { Container } from '@mui/material';\nimport React from 'react';\nimport { InboxCard } from './index';\n\nexport default (): React.ReactElement => {\n    return (\n        <Container maxWidth='sm'>\n            <InboxCard\n                onRequireResponseClick={() => showInfoSnackbar({ message: 'Notifications require response clicked' })}\n                onUnreadClick={() => showInfoSnackbar({ message: 'Unread notifications clicked' })}\n            />\n        </Container>\n    );\n};\n";